import Link from '@decisiv/ui-components/lib/components/Link';

import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedDepotsType } from '../..';

import { Highlighted } from './styles';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function NameCell({ rowData: { id, name } }: CellProps) {
  const { searchString } = useSearchContext();

  return (
    <Link
      to={`/management/depot/${id}`}
      text={<Highlighted text={name} searchText={searchString} />}
    />
  );
}
